import { SelectItemType } from "./common/types/selectItem.type";

export const LS_KEY_USER: string = "authUser";
export const LS_KEY_USERS: string = "users";
export const LANG_EN: string = "en";
export const LANG_TH: string = "th";
export const FILE_COUNT_LIMIT: number = 2;
export const DATE_FORMAT: string = "DD/MM/YYYY";
export const DATE_TIME_FORMAT: string = "DD/MM/YYYY HH:mm";
export const NOT_PUBLISHED: string = "not-to-publish-this-user-info";

export const LAYOUTS: { [key: string]: string } = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
  TWO_COLUMN: "twoColumn",
};

export const SIDEBAR_SIZE: { [key: string]: string } = {
  DEFAULT: "lg",
  COMPACT: "md",
  SMALL: "sm",
};

export const TOP_BAR: { [key: string]: string } = {
  LIGHT: "light",
  DARK: "dark",
};

export const LAYOUT_WIDTH: { [key: string]: string } = {
  FLUID: "fluid",
};

export const SIDEBAR_COLOR: { [key: string]: string } = {
  LIGHT: "light",
  DARK: "dark",
  GRADIENT: "gradient",
  GRADIENT2: "gradient-2",
  GRADIENT3: "gradient-3",
  GRADIENT4: "gradient-4",
};

export const LAYOUT_THEME: { [key: string]: string } = {
  DEFAULT: "default",
  MATERIAL: "material",
  CREATIVE: "creative",
  MINIMAL: "minimal",
  MODERN: "modern",
  INTERACTION: "interaction",
};

export const SITE_THEME = {
  LIGHT: "light",
  DARK: "dark",
  BRAND: "brand",
};

export const LAYOUT_POSITION = {
  FIXED: "fixed",
  SCROLLABLE: "scrollable",
};

export const PRELOADER = {
  ENABLE: "enable",
  DISABLE: "disable",
};

export const DIR = {
  LTR: "ltr",
  RTL: "rtl",
};

export const USER_BTN_KEY = {
  RESEND: "resend", //ยื่นอุทธรณ์
  CANCEL: "cancel",
  SAVE: "save", // ส่งเอกสารแนบ
};

export const ASC_BTN_KEY = {
  EXPORT: "export-pdf",
  HISTORY: "history",
  NEED_DOC: "need-more-doc",
  ASSIGN_DPM: "assign-dpm",
  VERIFY_DOC: "verify-doc",
  SEND_DOC: "send-doc-to-dpm",
  SAVE: "save",
  END: "end-complaint",
  RETURN_OCPB: "return-to-ocpb",
  RETURN_OPM: "return-to-opm", //TODO: opm have return ??
};

export const DPM_BTN_KEY = {
  EXPORT: "export-pdf",
  HISTORY: "history",
  SUMMARY: "summary",
  SAVE: "save",
  NEED_DOC: "need-more-doc",
  SEND_AIRLINE: "send-doc-to-airline",
  SEND_ASC: "send-doc-to-asc",
};

export const AIRLINE_BTN_KEY = {
  EXPORT: "export-pdf",
  SAVE: "save",
  SUBMIT: "submit",
  RETURN: "return",
};

export const AdminPaging = {
  itemsPerPage: 5,
  page: 1,
  items: [5, 10, 25, 50],
};

export const ComplaintPaging = {
  itemsPerPage: 100,
  page: 1,
  items: [25, 50, 100],
};

export const FLIGHT_STATUS = {
  UPCOMING: "Empty",
  ONTIME: "Scheduled",
  CONFIRMED: "Confirmed",
  CHECKIN: "Check In",
  BOARDING: "Boarding",
  FINALCALL: "Final Call",
  DEPARTED: "Departed",
  DELAYED: "DelayedLess30",
  DELAYED30: "DelayedMore30",
  CANCELLED: "Cancelled",
};

export const FLIGHT_STATUS_OPTIONS: SelectItemType[] = [
  // {
  //   color: "#215982",
  //   label: "flight-status-upcoming",
  //   value: FLIGHT_STATUS.UPCOMING,
  // },
  {
    color: "#00673F",
    label: "flight-status-ontime",
    value: FLIGHT_STATUS.ONTIME,
  },
  // {
  //   color: "#00673F",
  //   label: "flight-status-confirmed",
  //   value: FLIGHT_STATUS.CONFIRMED,
  // },
  // {
  //   color: "#00673F",
  //   label: "flight-status-checkin",
  //   value: FLIGHT_STATUS.CHECKIN,
  // },
  // {
  //   color: "#00673F",
  //   label: "flight-status-boarding",
  //   value: FLIGHT_STATUS.BOARDING,
  // },
  // {
  //   color: "#00673F",
  //   label: "flight-status-finalcall",
  //   value: FLIGHT_STATUS.FINALCALL,
  // },
  {
    color: "#215982",
    label: "flight-status-delayed-less-30",
    value: FLIGHT_STATUS.DELAYED,
  },
  {
    color: "#926100",
    label: "flight-status-delayed-more-30",
    value: FLIGHT_STATUS.DELAYED30,
  },
  {
    color: "#8B0D00",
    label: "flight-status-cancelled",
    value: FLIGHT_STATUS.CANCELLED,
  },
  // {
  //   color: "#00673F",
  //   label: "flight-status-departed",
  //   value: FLIGHT_STATUS.DEPARTED,
  // },
];

export const COMPLAINT_STATUS = {
  CAN_COMPLAINT: "complaint-flight",
  CANNOT_COMPLAINT: "non-complaint-flight",
};

export const COMPLAINT_STATUS_OPTIONS: SelectItemType[] = [
  {
    color: "#00673F",
    label: "allow-complaint",
    value: "complaint-flight",
  },
  {
    color: "#8B0D00",
    label: "not-allow-complaint",
    value: "non-complaint-flight",
  },
];

export const REQUEST_TYPE = {
  CPM: "CPM", //กพท.
  OCPB: "OCPB", //สคบ.
  OPM: "OPM", //สปน.
  MIGRATION: "MIGRATION",
};

export const REQUEST_STATUS = {
  DRAFT: "draft", //ร่าง
  ACTIVE: "active", //ส่งเรื่องร้องเรียนแล้ว
  REQUEST_DOC: "reqdoc", //ขอเอกสารเพิ่มเติม
  IN_PROGRESS: "inprog", //อยู่ในระหว่างดำเนินการ
  // UPLOADED: "uploaded", //แนบเอกสารแล้ว
  END: "end", //ยุติเรื่อง
  CANCELLED: "cancelled", //ยกเลิก
  APPEAL: "appeal", //ยื่นอุทธรณ์
};

export const REQUEST_STATUS_OPTIONS: SelectItemType[] = [
  { label: "status-draft", value: REQUEST_STATUS.DRAFT, color: "warning" },
  { label: "status-active", value: REQUEST_STATUS.ACTIVE, color: "success" },
  {
    label: "status-request-additional-document",
    value: REQUEST_STATUS.REQUEST_DOC,
    color: "primary",
  },
  {
    label: "status-in-progress",
    value: REQUEST_STATUS.IN_PROGRESS,
    color: "purple",
  },
  { label: "status-end", value: REQUEST_STATUS.END, color: "error" },
  {
    label: "status-cancelled",
    value: REQUEST_STATUS.CANCELLED,
    color: "error",
  },
  {
    label: "status-appeal",
    value: REQUEST_STATUS.APPEAL,
    color: "error",
  },
];

export const DPM_STATUS = {
  // NO_DPM: "set-department-waiting", //รอมอบหมายฝ่าย
  NO_PERSON: "set-responsible-person-waiting", //รอตั้งค่าผู้ดูแลเรื่องร้องเรียน
  IN_PROGRESS: "inprog", //อยู่ระหว่างดำเนินการ
  ASC_CONSIDER: "waiting-for-asc-consider", //รอ ASC พิจารณา
  REQUEST_DOC: "request-for-additional-documents", //แจ้งขอเอกสารเพิ่มเติม
  UPLOADED: "waiting-for-additional-documents-tobe-sent", //รอส่งเอกสารเพิ่มเติม
  END: "end", //แจ้งสรุปข้อเท็จจริง,
  RETURN: "return", //ส่งเอกสารคืน
  WAIT_AIRLINE: "wait-airline", //อยู่ระหว่างการตรวจสอบ
  ACCEPTED: "accepted", //รับข้อเท็จจริง
};

export const DPM_STATUS_OPTIONS: SelectItemType[] = [
  // {
  //   label: "status-dpm-no-dpm",
  //   value: DPM_STATUS.NO_DPM,
  //   color: "warning",
  // },
  {
    label: "status-dpm-no-person",
    value: DPM_STATUS.NO_PERSON,
    color: "warning",
  },
  {
    label: "status-dpm-in-progress",
    value: DPM_STATUS.IN_PROGRESS,
    color: "warning",
  },
  {
    label: "status-dpm-asc-consider",
    value: DPM_STATUS.ASC_CONSIDER,
    color: "primary",
  },
  {
    label: "status-dpm-request-doc",
    value: DPM_STATUS.REQUEST_DOC,
    color: "primary",
  },
  {
    label: "status-dpm-uploaded",
    value: DPM_STATUS.UPLOADED,
    color: "primary",
  },
  {
    label: "status-dpm-wait-airline",
    value: DPM_STATUS.WAIT_AIRLINE,
    color: "primary",
  },
  {
    label: "status-dpm-return",
    value: DPM_STATUS.RETURN,
    color: "success",
  },
  {
    label: "status-dpm-end",
    value: DPM_STATUS.END,
    color: "success",
  },
  {
    label: "status-dpm-airline-accepted",
    value: DPM_STATUS.ACCEPTED,
    color: "success",
  },
];

export const FORMAT_CHANNEL = {
  manual: "manual-input",
  option: "option-selection",
};

export const FORMAT_CHANNEL_OPTIONS: SelectItemType[] = [
  { label: "manual-input", value: FORMAT_CHANNEL.manual },
  { label: "option-selection", value: FORMAT_CHANNEL.option },
];

export const FLIGHT_UNIT: SelectItemType[] = [
  { label: "domestic-airline", value: "domestic" },
  { label: "international-airline", value: "international" },
];

export const ACTIVE_STATUS_OPTIONS: SelectItemType[] = [
  { label: "active", value: 1 },
  { label: "inactive", value: 0 },
];

export const FORM_STEP = {
  FlightDelails: 1,
  Passengers: 2,
  Complaints: 3,
};

export const STEP3_SECTION = {
  COMPLAINT: "card-complaint",
  DETAIL: "card-incident",
  REPORT: "card-reported",
  ATTACH: "card-attachment",
  REQUEST: "card-list",
};

export const STEP_ONE = {
  Detail: 1,
  Channel: 2,
};

export const STEP_TWO = {
  Detail: 1,
  Published: 2,
};

export const STEP_THREE = {
  AirlineNotified: 1,
  DelayHour: 2,
  Baggage: 3,
  NeedRefundForService: 4,
  NeedDetail: 5,
  NotifiedAirline: 6,
  Attachment: 7,
  Request: 8,
  RequestAirlinePay: 9,
  RequestAirlineRefund: 10,
  RequestAirlineChangeFlight: 11,
  RequestChangeRule: 12,
  RequestOther: 13,
};

export const BAGGAGE_OPTIONS: SelectItemType[] = [
  { label: "baggage-destroyed", value: 1 },
  { label: "baggage-lost", value: 2 },
  { label: "baggage-damaged", value: 3 },
  { label: "baggage-delayed", value: 4 },
];

export const REFUND_OPTIONS: SelectItemType[] = [
  { label: "refund-service", value: 1 },
];

export const ATTACH_TYPE = {
  NEW: "new",
  SAVED: "saved",
};

export const ATTACHMENT_OPTIONS = [
  {
    label: "complaint-req-doc-booking",
    value: 1,
  },
  {
    label: "complaint-req-doc-airline",
    value: 2,
  },
  {
    label: "t-complaint-req-doc-other",
    value: 3,
  },
];

export const ADD_DOCS_STATUS = {
  NEW: "waitng",
  APPROVED: "approved",
  NONAPPROVE: "non-approve",
  UPLOADED: "uploaded",
  COMPLETED: "completed",
};

export const ADD_DOCS_STATUS_OPTIONS: SelectItemType[] = [
  { label: "รออนุมัติจาก ASC", value: ADD_DOCS_STATUS.NEW },
  { label: "ขอเอกสารเพิ่มเติม", value: ADD_DOCS_STATUS.APPROVED },
  { label: "ASC ไม่อนุมัติ", value: ADD_DOCS_STATUS.NONAPPROVE },
  { label: "ผู้ร้องเรียนแนบเอกสารสำเร็จ", value: ADD_DOCS_STATUS.UPLOADED },
  { label: "ตรวจเอกสารสำเร็จ", value: ADD_DOCS_STATUS.COMPLETED },
];

export const OPINION = {
  END_COMPLAINT: "end-the-complaint",
  END_WITH_AGRMNT: "end-with-manager-agreement",
  COORDINATE: "coordinate-with-other-dpm",
};

export const OPINION_OPTIONS: SelectItemType[] = [
  { label: "opinion-end-the-complaint", value: OPINION.END_COMPLAINT },
  {
    label: "opinion-end-with-manager-agreement",
    value: OPINION.END_WITH_AGRMNT,
  },
  {
    label: "opinion-coordinate-with-other-dpm",
    value: OPINION.COORDINATE,
  },
];

export const TITLE_OPTIONS: SelectItemType[] = [
  { label: "title-mr", value: "mr" },
  { label: "title-mrs", value: "mrs" },
  { label: "title-ms", value: "ms" },
  { label: "title-none", value: "none" },
];

export const LOG_CODE = {
  createRequestNo: "{create-request-no}",
  saveComplaintRequest: "{save-complaint-request}",
  requestNo: "{request-no}",
  sendComplaintRequest: "{send-complaint-request}",
  successfully: "{successfully}",
  assignDepartment: "{assign-department}",
  requestAdditionalDoc: "{request-additional-doc}",
  considerAdditionalDoc: "{consider-additional-doc}",
  summaryResult: "{summary-result}",
  cancelRequestNo: "{cancel-request-no}",
  endRequestNo: "{end-request-no}",
  changeResponsiblePerson: "{change-responsible-person}",
  summaryByExternalDpm: "{summary-result-by-external-department}",
  sendToExternalDpm: "{sent-to-external-department}",
  returnResult: "{return-result}",
  reason: "{reason}",
  return: "{return-document-by-external-department}",
  userSendDoc: "{complainant-send-additional-doc}",
  sendToMainResp: "{sent-to-main-responsible}",
  saveSummaryResult: "{save-summary-result}",
  appealRequestNo: "{appeal-request-no}",
};

export const ErrorCodeAuth = {
  EXIST_EXTERNAL_USER: "existing-account-on-external-user",
  EXIST_EXTERNAL_EMAIL: "existing-account-on-external-email",
  EXIST_EXTERNAL_USERNAME: "existing-account-on-external-username",
  EXIST_STAKEHOLDER_USER: "existing-account-on-stakeholder-user",
  EXIST_STAKEHOLDER_EMAIL: "existing-account-on-stakeholder-email",
  EXIST_STAKEHOLDER_USERNAME: "existing-account-on-stakeholder-username",
};

export const REQUEST_TYPE_OPTIONS: SelectItemType[] = [
  { label: "request-caat", value: REQUEST_TYPE.CPM, color: "primary" },
  { label: "request-ocpb", value: REQUEST_TYPE.OCPB, color: "warning" },
  { label: "request-opm", value: REQUEST_TYPE.OPM, color: "purple" }
];

export const REQUEST_TYPE_EXPORT: SelectItemType[] = [
  { label: "request-caat", value: REQUEST_TYPE.CPM, color: "primary" },
  { label: "request-ocpb", value: REQUEST_TYPE.OCPB, color: "warning" },
  { label: "request-opm", value: REQUEST_TYPE.OPM, color: "purple" },
  { label: "request-caat", value: REQUEST_TYPE.MIGRATION, color: "primary" }
];

export const OPM_STATUS_OPTIONS: SelectItemType[] = [
  { label: "รับเรื่อง", value: 1, color: "success" },
  { label: "ยุติเรื่อง (ไม่ได้ตามคำร้อง)", value: 10, color: "error" },
  { label: "ยุติเรื่อง", value: 99, color: "error" },
];
